<!-- Top bar -->
<mat-toolbar class="topBar" style="justify-content: space-between;">
    <!-- Left Side Content -->
    <div style="display: flex; align-items: center; gap: 20px;">
  
      <!-- Back button -->
      <button mat-mini-fab
              class="example-icon"
              type="button"
              aria-label="Back"
              [matTooltip]="partOfDraftTrip != -1 ? 'Back to Drafts' : setIndex == -1 || previousScreen == 'delivery' ? 'Back to Delivery' : previousScreen == 'deliveries_list' ? 'Back to Deliveries' : 'Back to Home'"
              matTooltipPosition="below"
              (click)="handleExit(partOfDraftTrip != -1 || setIndex == -1 || previousScreen == 'delivery' ? 'trawl_delivery' : previousScreen == 'deliveries_list' ? 'deliveries_list' : 'menu')">
        <mat-icon>arrow_back</mat-icon>
      </button>
  
      <!-- Home button -->
      <button mat-mini-fab
              class="example-icon"
              type="button"
              matTooltip="Home"
              matTooltipPosition="below"
              aria-label="Home"
              (click)="handleExit('menu')">
        <mat-icon>home</mat-icon>
      </button>
     
    </div>

    <!-- Title -->
    <span style="color: white;">Haul</span>

    <!-- Right Side Buttons -->
    <div style="display: flex; align-items: center; gap: 20px;">
      <!-- Delete Button -->
      <button *ngIf="!isReadOnly && partOfDraftTrip == -1"
        mat-mini-fab
        class="blue-icon-button"
        matTooltip="Delete"
        matTooltipPosition="below"
        aria-label="Delete"
        (click)="confirmDelete()">
      <mat-icon>delete</mat-icon>
    </button>

      <!-- Set Errors -->
      <button *ngIf="!isReadOnly"
            mat-mini-fab
            [matBadge]="errorNumber" [matBadgeHidden]="errorNumber == 0" matBadgePosition="above before"
            class="blue-icon-button"
            type="button"
            matTooltip="Errors"
            matTooltipPosition="below"
            [disabled]="setDetailForm.valid"
            (click)="openErrorDialog()">
        <mat-icon>priority_high</mat-icon>
      </button>
    </div>
</mat-toolbar>
  
  
  <br>
  
  <!-- The form for all of the input fields -->
  <form [formGroup]="setDetailForm">
    <div class="container" style="max-width: none;;">

      <div class="row">
        <div class="col">
          <div class="row">
            <mat-form-field appearance="fill">
              <mat-label>Strategy</mat-label>
              <input matInput formControlName="targetSpecies" [matAutocomplete]="dept" required>
              <button *ngIf="setIndex !== 0"
                      mat-mini-fab
                      matSuffix
                      class="blue-icon-button"
                      style="margin-right: 8px; color: white; background-color: #005d87"
                      type="button"
                      aria-label="Copy from last set"
                      matTooltip="Copy strategy, net type & codend from previous set"
                      matTooltipPosition="below"
                      (click)="copyFromPreviousSet(); $event.stopPropagation();">
                <mat-icon>
                  content_copy
                </mat-icon>
              </button>
              <mat-autocomplete #dept="matAutocomplete">
                <mat-option *ngFor="let opt of filteredTargetSpeciesList | async" [value]="opt">{{opt.name}}</mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="row">
            <mat-form-field appearance="fill">
              <mat-label>Net Type</mat-label>
              <mat-select formControlName="netType" [compareWith]="compareNetType" required>
                <mat-option *ngFor="let type of netTypesList | async" [value]="type">{{type.name}}</mat-option>
              </mat-select>
              <mat-error *ngIf="setDetailForm.invalid"></mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <mat-form-field appearance="fill">
              <mat-label>Codend Capacity (lbs)</mat-label>
              <input matInput type="number" formControlName="codendCapacity" />
              <mat-error *ngIf="setDetailForm.get('codendCapacity')?.errors?.required">Required for EM trips</mat-error>
              <mat-error *ngIf="setDetailForm.get('codendCapacity')?.errors?.max">Max capacity is 750,000 lbs</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
  
      <br>
  
      <!-- Set Info -->
      <div class="row">
        <mat-toolbar class="mat-toolbar-section">
          <span>Haul Start Info</span>
          <span class="spacer"></span>
  
          <!-- Fill set with current time and location -->
          <button *ngIf="!isReadOnly"
                  mat-mini-fab
                  class="blue-icon-button"
                  type="button"
                  matTooltip="Fill Set Time and Location"
                  matTooltipPosition="below"
                  (click)="fillSetTimeLocation()">
            <mat-icon>pin_drop</mat-icon>
          </button>
        </mat-toolbar>
      </div>
  
      <div class="row" style="padding-top: 20px;">
        <mat-form-field appearance="fill">
          <mat-label>Start Date and Time</mat-label>
          <input matInput readonly formControlName="startDate"
                 (click)="editDateTime('startDate')" required>
        </mat-form-field>
      </div>
  
      <div class="row">
        <div class="col">
          <div class="row">
            <mat-form-field appearance="fill">
              <mat-label>Start Latitude</mat-label>
              <input #startLat matInput readonly type="tel"
                     formControlName="startLat"
                     (click)="openCoordinateDialog('startLat')" required>
              <mat-error *ngIf="setDetailForm.get('startLat')?.errors?.shpLatError">
                Coordinate out of range
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <mat-form-field appearance="fill">
              <mat-label>Start Longitude</mat-label>
              <input #startLon matInput readonly type="tel"
                     formControlName="startLon"
                     (click)="openCoordinateDialog('startLon')" required>
              <mat-error *ngIf="setDetailForm.get('startLon')?.errors?.shpLonError">
                Coordinate out of range
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
  
      <br>
  
      <!-- Retrieve Info -->
      <div class="row">
        <mat-toolbar class="mat-toolbar-section">
          <span>Haul End Info</span>
          <span class="spacer"></span>
  
          <!-- Fill haul with current time and location -->
          <button *ngIf="!isReadOnly"
                  mat-mini-fab
                  class="blue-icon-button"
                  type="button"
                  matTooltip="Fill Haul Time and Location"
                  matTooltipPosition="below"
                  (click)="fillHaulTimeLocation()">
            <mat-icon>pin_drop</mat-icon>
          </button>
        </mat-toolbar>
      </div>
  
      <div class="row" style="padding-top: 20px;">
        <mat-form-field appearance="fill">
          <mat-label>End Date and Time</mat-label>
          <input matInput readonly formControlName="endDate"
                 (click)="editDateTime('endDate')" required>
          <mat-error *ngIf="setDetailForm.get('endDate')?.errors?.setAfterHaul">
            Haul must be after set
          </mat-error>
        </mat-form-field>
      </div>
  
      <div class="row">
        <div class="col">
          <div class="row">
            <mat-form-field appearance="fill">
              <mat-label>End Latitude</mat-label>
              <input matInput readonly type="tel"
                     formControlName="endLat"
                     (click)="openCoordinateDialog('endLat')" required>  
              <mat-error *ngIf="setDetailForm.get('endLat')?.errors?.shpLatError">Coordinate out of range</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <mat-form-field appearance="fill">
              <mat-label>End Longitude</mat-label>
              <input matInput readonly type="tel"
                     formControlName="endLon"
                     (click)="openCoordinateDialog('endLon')" required>
              <mat-error *ngIf="setDetailForm.get('endLon')?.errors?.shpLonError">
                Coordinate out of range
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
  
      <!-- Average Depth -->
      <div class="row">
        <div class="col">
          <div class="row">
            <mat-form-field appearance="fill">
              <mat-label>Average Depth (fathoms)</mat-label>
              <input matInput type="number" formControlName="averageDepth" required>
              <mat-error *ngIf="setDetailForm.get('averageDepth')?.invalid"></mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Lost net -->
      <mat-divider></mat-divider>
      <div style="display: flex; flex-direction: column; margin-top: 10px; margin-bottom: 10px;">

        <div style="display: flex; align-items: center;">
          <h2 style="margin-bottom: 0px; margin-right: 20px;">Lost Net?</h2>
          <mat-radio-group aria-label="Select an option" formControlName="lostNet">
            <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false" style="padding-left: 25px;">No</mat-radio-button>
          </mat-radio-group>  
        </div>
        
        <span *ngIf="setDetailForm.get('lostNet')?.value === true" style="color: #e65100; font-size: 14px; font-style: italic; font-weight: bold;">
          Warning: you've selected lost net, meaning that your entire net was lost. If this is correct, please disregard this warning.
        </span>

      </div>
      <mat-divider></mat-divider>
      <br>
  
      <!-- Catch -->
      <div class="row">
        <mat-toolbar class="mat-toolbar-section">
          <span>Catch</span>
          <span class="spacer"></span>
  
          <!-- Add a new catch -->
          <button *ngIf="!isReadOnly"
                  mat-mini-fab
                  class="blue-icon-button"
                  type="button"
                  aria-label="Add Catch"
                  matTooltip="Add New Catch"
                  matTooltipPosition="below"
                  (click)="openCatchDialog(fishingEvent.catchItems.length)">
            <mat-icon>add</mat-icon>
          </button>
        </mat-toolbar>
      </div>
  
      <!-- Catch data -->
      <div class="row">
        <table mat-table [dataSource]="fishingEvent.catchItems"> 
          <ng-container matColumnDef="Species">
            <th mat-header-cell *matHeaderCellDef>Species</th>
            <td mat-cell *matCellDef="let item">{{item.species.name}}</td>
          </ng-container>
           
          <ng-container matColumnDef="RetainedWeight">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="retainedCountPresent ? 1 : 2">
              Weight
            </th>
            <td mat-cell *matCellDef="let item" style="text-align: center;" [attr.colspan]="retainedCountPresent ? 1 : 2">
              {{item.retainedWeight ?? '-'}}
            </td>
          </ng-container>

          <ng-container matColumnDef="RetainedCount">
            <th mat-header-cell *matHeaderCellDef style="border-right: 1px solid black;">
              Count
            </th>
            <td mat-cell *matCellDef="let item" style="text-align: center; border-right: 1px solid black;">
              {{item.retainedCount ?? '-'}}
            </td>
          </ng-container>
  
          <ng-container matColumnDef="ReleasedWeight">
            <th mat-header-cell *matHeaderCellDef>Weight</th>
            <td mat-cell *matCellDef="let item" style="text-align: center;">
              {{item.releasedWeight ?? '-'}}
            </td>
          </ng-container>

          <ng-container matColumnDef="ReleasedCount">
            <th mat-header-cell *matHeaderCellDef>Count</th>
            <td mat-cell *matCellDef="let item" style="text-align: center;">
              {{item.releasedCount ?? '-'}}
            </td>
          </ng-container>
  
          <ng-container matColumnDef="Filler">
            <th mat-header-cell *matHeaderCellDef></th>
          </ng-container>
  
          <ng-container matColumnDef="Retained">
            <th mat-header-cell *matHeaderCellDef colspan="2" style="border-right: 1px solid black;">
              Retained
            </th>
          </ng-container>
  
          <ng-container matColumnDef="Released">
            <th mat-header-cell *matHeaderCellDef colspan="2">
              Released
            </th>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="['Filler', 'Retained', 'Released']" class="catch-first-header"></tr>
          <tr mat-header-row *matHeaderRowDef="catchTableColumns" class="catch-second-header"></tr>
          <tr mat-row *matRowDef="let row; columns: catchTableColumns; let index=index;"
              (click)="openCatchDialog(index)">
          </tr>
        </table>
      </div>
  
      <!-- Comments -->
      <div class="row">
        <mat-toolbar class="mat-toolbar-section">
          <span>Comments</span>
        </mat-toolbar>
      </div>
  
      <div class="row">
        <mat-form-field appearance="fill">
          <mat-label>Additional Comments</mat-label>
          <textarea matInput rows="9" formControlName="comments" [maxlength]="250"></textarea>
        </mat-form-field>
      </div>
  
      <br><br><br><br><br>
  
    </div>
  </form>
  
  <!-- Bottom bar -->
  <mat-toolbar class="toolbarNav" style="background-color: #004165; padding-left: 10px; padding-right: 10px;">
  
      <div style="flex-grow: 1; display: flex; justify-content: space-evenly;">
        <!-- Go to Previous Set -->
      <button *ngIf="!isReadOnly && partOfDraftTrip == -1"
      mat-fab
      class="bottom-toolbar-button"
      type="button"
      aria-label="Previous Set"
      matTooltip="Previous Set"
      matTooltipPosition="above"
      (click)="previousSet()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <!-- Add New Set -->
    <button *ngIf="!isReadOnly && partOfDraftTrip == -1"
      mat-fab
      class="bottom-toolbar-button"
      type="button"
      aria-label="Add Set"
      matTooltip="Add Set"
      matTooltipPosition="above"
      (click)="addSet()">
      <mat-icon>add</mat-icon>
    </button>

    <!-- Go to Next Set -->
    <button *ngIf="!isReadOnly && partOfDraftTrip == -1"
      mat-fab
      class="bottom-toolbar-button"
      type="button"
      aria-label="Next Set"
      matTooltip="Next Set"
      matTooltipPosition="above"
      (click)="nextSet()">
      <mat-icon>arrow_forward</mat-icon>
    </button>
      </div>

    <button *ngIf="!isReadOnly && partOfDraftTrip == -1"
              mat-fab
              class="blue-icon-button"
              matTooltip="Delivery"
              matTooltipPosition="below"
              aria-label="Delivery"
              (click)="navigateToDelivery()">
        <mat-icon>drive_folder_upload</mat-icon>
      </button>
    
  </mat-toolbar>
